import * as Sentry from "@sentry/browser";
import axios from "axios";
import qs from "query-string";
import React, { useEffect, useState } from "react";
import { batch, connect, ConnectedProps } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import { Label, SectionTitle } from "sweet-web/components/universal/Text";
import { Section, Wrapper } from "sweet-web/components/universal/View";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import { linkStripe, UpdateVenue } from "sweet-web/redux/venue/actions";

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const LinkStripe: React.FC<Props> = props => {
  const [linked, setLinked] = useState(false);
  const { stripeState } = props;

  const params = qs.parse(props.location.search);

  let stripeStateFromCode: string,
    venueId: string = null;

  if (params.code && params.state) {
    if (typeof params.state != "string" || typeof params.code != "string") {
      alert(
        "Could not verify stripe connection. Our team has been notified and we will be in touch"
      );

      return <Redirect to="/listings" />;
    }

    [stripeStateFromCode, venueId] = params.state.split(":");

    if (stripeState !== stripeStateFromCode) {
      // something went wrong, maybe a venue is being hacked
      Sentry.captureMessage("incorrect stripe state");
      alert(
        "Could not verify stripe connection. Our team has been notified and we will be in touch"
      );

      return <Redirect to="/listings" />;
    } else {
      // got authorization code, add to venue entity and redirect => further linking happens in cloud functions
      batch(() => {
        props.UpdateVenue(venueId, {
          stripeAuthCode: params.code as string
        });
      });
      setLinked(true);
    }
  }

  if (linked) return <Redirect to={`/listing/${venueId}/payment`} />;

  if (!linked)
    return (
      <Wrapper>
        <Section>
          <SectionTitle style={{ marginBottom: 0 }}>
            Setting up your account to receive payments
          </SectionTitle>
          <Label>Wait a moment while we verify things and get set up...</Label>
        </Section>
      </Wrapper>
    );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => ({
  stripeState: selectors.linkStripe(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      linkStripe,
      UpdateVenue
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(LinkStripe);
